/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_SubInputs */

const en_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes on modern tech, developer tooling, system design, and cross-platform development, based on what i'm actually building and using.`)
};

const ar_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاحظات عن التقنيات الحديثة، وأدوات المطورين، وتصميم الأنظمة، والتطوير متعدد المنصات, بناءً على ما أبنيه وأستخدمه فعليًا.`)
};

const bn_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আধুনিক টেক, ডেভেলপার টুল, সিস্টেম ডিজাইন ও ক্রস-প্ল্যাটফর্ম ডেভেলপমেন্ট নিয়ে লেখা, নিজে যা বানাই ও ব্যবহার করি, তার অভিজ্ঞতা থেকে।`)
};

const de_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen zu moderner Technologie, Entwickler-Tools, Systemdesign und plattformübergreifender Entwicklung – aus dem, was ich tatsächlich baue und nutze.`)
};

const es_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas sobre tecnología moderna, herramientas para desarrolladores, diseño de sistemas y desarrollo multiplataforma, basadas en lo que construyo y uso.`)
};

const fr_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes sur les technologies modernes, les outils pour développeurs, l’architecture des systèmes et le développement multiplateforme, fondées sur ce que je construis et utilise.`)
};

const pt_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas sobre tecnologia moderna, ferramentas para desenvolvedores, arquitetura de sistemas e desenvolvimento multiplataforma, com base no que construo e uso.`)
};

const zh_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于现代技术、开发者工具、系统设计和跨平台开发的笔记，基于我实际在做在用的东西。`)
};

const tr_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern teknoloji, geliştirici araçları, sistem tasarımı ve platformlar arası geliştirme üzerine, gerçekte oluşturduğum ve kullandığım şeye dayalı notlar.`)
};

const ru_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заметки о современных технологиях, инструментах разработчика, проектировании систем и кроссплатформенной разработке на основе того, что я на самом деле создаю и использую.`)
};

const pl_notes_sub = /** @type {(inputs: Notes_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notatki na temat nowoczesnych technologii, narzędzi dla programistów, projektowania systemów i rozwoju międzyplatformowego, w oparciu o to, co aktualnie tworzę i używam.`)
};

/**
* | output |
* | --- |
* | "Notes on modern tech, developer tooling, system design, and cross-platform development, based on what i'm actually building and using." |
*
* @param {Notes_SubInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const notes_sub = /** @type {((inputs?: Notes_SubInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_SubInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_notes_sub(inputs)
	if (locale === "bn") return bn_notes_sub(inputs)
	if (locale === "de") return de_notes_sub(inputs)
	if (locale === "es") return es_notes_sub(inputs)
	if (locale === "fr") return fr_notes_sub(inputs)
	if (locale === "pt") return pt_notes_sub(inputs)
	if (locale === "zh") return zh_notes_sub(inputs)
	if (locale === "tr") return tr_notes_sub(inputs)
	if (locale === "ru") return ru_notes_sub(inputs)
	if (locale === "pl") return pl_notes_sub(inputs)
	return en_notes_sub(inputs)
});